var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Prop, Emit } from 'vue-property-decorator';
import { RepairCasesService } from '~/services/domain-service/repair-cases.service';
import { namespace } from "vuex-class";
var AllotModule = namespace("case-allot");
var MessageBution = /** @class */ (function (_super) {
    __extends(MessageBution, _super);
    function MessageBution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataArray = {};
        /**
         * table数据源
         */
        _this.dataSet = [];
        return _this;
    }
    /**
     * 首次打开执行
     */
    MessageBution.prototype.refreshData = function () {
        this.display.forEach(function (x) { return x.num = 0; });
        this.dataSet = this.display;
    };
    MessageBution.prototype.emitSuccess = function () {
        this.dataSet = [];
    };
    MessageBution.prototype.emitBack = function () {
    };
    MessageBution.prototype.emitClose = function () {
    };
    /**
     * 输入验证
     */
    MessageBution.prototype.onNumBlur = function (e) {
        if (e.target.valueAsNumber > this.caseIds.length) {
            this.$message.error(e.target.validationMessage);
        }
        else {
            var alreadySum = this.dataSet.reduce(function (a, c) { return a + Number.parseInt(c.num || "0"); }, 0);
            if (alreadySum > this.caseIds.length) {
                this.$message.error("输入数量不能大于选中分案数量");
            }
        }
    };
    /**
     * 确定分配
     */
    MessageBution.prototype.submit = function () {
        var _this = this;
        this.dataArray.distributeNumber = this.dataSet.map(function (v) { return v.num; });
        var alreadySum = this.dataSet.reduce(function (a, c) { return a + Number.parseInt(c.num || "0"); }, 0);
        if (alreadySum > this.caseIds.length) {
            this.$message.error("输入数量不能大于选中分案数量");
            return;
        }
        this.dataArray.caseIds = this.caseIds;
        this.dataArray.userIds = this.dataSet.map(function (v) { return v.id; });
        this.dataArray.deptIds = this.dataSet.map(function (v) { return v.deptId; });
        this.dataArray.distributeCategory = "TO_COLLECTOR";
        this.repairCasesService.confirmDistributeCase(this.dataArray).subscribe(function (data) {
            _this.$message.success('操作成功');
            _this.emitClose();
        });
    };
    __decorate([
        Dependencies(RepairCasesService)
    ], MessageBution.prototype, "repairCasesService", void 0);
    __decorate([
        AllotModule.State
    ], MessageBution.prototype, "caseIds", void 0);
    __decorate([
        Prop()
    ], MessageBution.prototype, "display", void 0);
    __decorate([
        Emit("success")
    ], MessageBution.prototype, "emitSuccess", null);
    __decorate([
        Emit("back")
    ], MessageBution.prototype, "emitBack", null);
    __decorate([
        Emit("close")
    ], MessageBution.prototype, "emitClose", null);
    MessageBution = __decorate([
        Component({
            components: {},
        })
    ], MessageBution);
    return MessageBution;
}(Vue));
export default MessageBution;
